// extracted by mini-css-extract-plugin
module.exports = {"zone":"zone_zone__2hj6q","has-border":"zone_has-border__kiu4b","has-background":"zone_has-background__2JnCm"};